module.exports = __webpack_public_path__ + "static/media/19ESCAP32.acf5e0d0.jpg";